var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useCallback } from "react";
import { createContext, useContext } from "react";
import { useLibZLInstance } from "./LibZLInstanceProvider";
export const ZLBoltInstanceContext = createContext(null);
export const useZLBoltInstance = () => useContext(ZLBoltInstanceContext);
export const ZLBoltInstanceProvider = ({ projectName, configure, children }) => {
    const libZL = useLibZLInstance();
    const [zlbolt, setZLBolt] = useState(null);
    const createZLBoltInstance = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!libZL) {
            return;
        }
        const zlbolt = libZL.zlbolt(projectName);
        const resolvedZlbolt = zlbolt instanceof Promise ? yield zlbolt : zlbolt;
        window.zlbolt = resolvedZlbolt;
        try {
            if (configure) {
                configure(resolvedZlbolt);
            }
        }
        catch (_a) {
            console.error("Failed to configure ZLBolt instance");
        }
        setZLBolt(resolvedZlbolt);
    }), [libZL, projectName, configure]);
    useEffect(() => {
        createZLBoltInstance();
    }, [createZLBoltInstance]);
    return (React.createElement(ZLBoltInstanceContext.Provider, { value: zlbolt }, children));
};
